import React from "react";
import Header from "../../headerone/Main";
import Bredcom from "../../Bredcom/Main";
import BlogTwo from "../../Blogdetails/BlogTwo";

function Main() {
  return (
    <>
      <section className="hide-overflow">
        <Header />
        <Bredcom
          title="Home"
          subtitle="Essential Skills Every Pharmacy Student Should Develop"
        />
        <BlogTwo />
      </section>
    </>
  );
}

export default Main;
